export function getAmplifyConfig() {
  const cfg = {
    Auth: {
      Cognito: {
        userPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID,
        userPoolClientId: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
        identityPoolId: process.env.NEXT_PUBLIC_COGNITO_IDENTITY_POOL,
        signUpVerificationMethod: "code",
      },
    },
    API: {
      GraphQL: {
        endpoint: process.env.NEXT_PUBLIC_GRAPHQL_API,
        region: process.env.NEXT_PUBLIC_MY_REGION,
        defaultAuthMode: "userPools",
      },
    },
  };

  return cfg;
}
